var render, staticRenderFns
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2378cf2b')) {
      api.createRecord('2378cf2b', component.options)
    } else {
      api.reload('2378cf2b', component.options)
    }
    
  }
}
component.options.__file = "found/views/sfa/views/performance_manage/index_set/form.vue"
export default component.exports